/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';

import { IInstrumento } from '../../../services/api/dams/DamServices';

interface ReProps {
    data: IInstrumento
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    validations: any;
}

export const Re: React.FC<ReProps> = ({ data, handleChange, validations }) => {

    return (
        <Box width={'100%'}>
            <Grid container direction={'column'} padding={2} spacing={2}>
                <Grid container item direction={'row'} spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Dados do Instrumento</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Elevação'}
                            id='elevacao'
                            value={data.elevacao || ''}
                            onChange={handleChange}
                            type='number'
                            error={validations.elevacao}
                            required
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Unidade de medida'}
                            id='unidade_medida'
                            value={data.unidade_medida || ''}
                            onChange={handleChange}
                            error={validations.unidade_medida}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Tipo'}
                            id='tipo'
                            value={data.tipo || ''}
                            onChange={handleChange}
                            error={validations.tipo}
                            required
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};